import { render, staticRenderFns } from "./TsPanelCustomScroll.vue?vue&type=template&id=44e835f1&"
import script from "./TsPanelCustomScroll.vue?vue&type=script&lang=js&"
export * from "./TsPanelCustomScroll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports